var map = {
	"./access_def.svg": "eMdW",
	"./contact-fill.svg": "T/ha",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./home.svg": "U9Ws",
	"./home_def.svg": "1qp9",
	"./huodongxiangqu.svg": "6X2i",
	"./integral_def.svg": "lrWI",
	"./inventory_def.svg": "mE25",
	"./login-mall.svg": "xzZT",
	"./logo.svg": "ZY77",
	"./market_def.svg": "/A7l",
	"./password.svg": "QjmH",
	"./personal_def.svg": "vQ1f",
	"./procur_def.svg": "ukEy",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./return_def.svg": "eZXb",
	"./sales_def.svg": "Au+r",
	"./shopp_def.svg": "LhmX",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 44